import { ErrorData } from '@membranehq/sdk'
import { OpenChangeDetails } from '@zag-js/dialog'
import { useState, ReactNode, useEffect } from 'react'
import * as UiKitPopup from 'ui-kit/styled/popup'

import { Popup } from '../Popup'
import { ErrorBadge, ErrorJSON } from './components'
import { errorPopupMachine, showErrorInPopup } from './error-popup-utils'
import { ErrorItem } from './ErrorItem'

export const ErrorPopupProvider = ({ children }: { children: ReactNode }) => {
  const [error, setError] = useState<ErrorData | null>(null)
  const [popupProps, setPopupProps] = useState<Partial<UiKitPopup.RootProps> | null>(null)

  useEffect(() => {
    return errorPopupMachine.subscribe((state) => {
      setPopupProps(state.context.popupProps ?? null)
      setError(state.context.error ?? null)
    })
  }, [])

  function handleOnOpenChange(details: OpenChangeDetails) {
    if (!error) {
      return
    }
    popupProps?.onOpenChange?.(details)
    if (!details.open) {
      showErrorInPopup(null)
    }
  }

  return (
    <>
      {children}
      <ErrorPopup error={error} open={!!error} {...(popupProps ?? {})} onOpenChange={handleOnOpenChange} />
    </>
  )
}

function ErrorPopup({ error, ...props }: { error?: ErrorData | null } & UiKitPopup.RootProps) {
  if (!error) return null

  return (
    <Popup.Root {...props}>
      <Popup.Window usePortal zIndex={1600} className='max-w-3xl'>
        <Popup.Header>
          <ErrorItem.Header>
            <ErrorBadge error={error} />
            <ErrorItem.Title>{error.message}</ErrorItem.Title>
          </ErrorItem.Header>
        </Popup.Header>
        <Popup.Content>
          <ErrorItem.Root>
            <ErrorJSON error={error} />
          </ErrorItem.Root>
        </Popup.Content>
      </Popup.Window>
    </Popup.Root>
  )
}
